import { z } from "zod";
export var paginationSchema = z.object({
    pageCount: z.number(),
    pageNumber: z.number(),
    pageSize: z.number(),
    totalCount: z.number()
});
//# sourceMappingURL=Pagination.zod.js.map